import api, { unwrap } from '../finance/api/client';

export const docsApi = {
  // 1. List API Documentation Catalog with search & filters
  listCatalog: async (params = {}) => {
    const res = await api.get('/docs', { params });
    return unwrap(res);
  },

  // 2. Get Document Details & Endpoints for a specific version
  getDocumentDetail: async (id, version) => {
    const res = await api.get(`/docs/${id}`, {
      params: version ? { version } : {},
    });
    return unwrap(res);
  },

  // 3. Pre-upload validation check
  validateDocument: async (file, directJson) => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      const res = await api.post('/docs/validate', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return unwrap(res);
    }
    const res = await api.post('/docs/validate', directJson, {
      headers: { 'Content-Type': 'application/json' },
    });
    return unwrap(res);
  },

  // 4. Upload new API Documentation
  uploadDocument: async (formData) => {
    const res = await api.post('/docs/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return unwrap(res);
  },

  // 5. Upload new version for existing documentation
  uploadVersion: async (id, formData) => {
    const res = await api.post(`/docs/${id}/version`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return unwrap(res);
  },

  // 6. Download Full OpenAPI JSON specification file
  downloadFullDocument: async (id, version) => {
    const res = await api.get(`/docs/${id}/download`, {
      params: version ? { version } : {},
      responseType: 'blob',
    });
    const disposition = res.headers['content-disposition'] || '';
    let filename = `api-documentation-v${version || 'latest'}.json`;
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = match[1];
    }
    const blob = new Blob([res.data], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },

  // 7. Download individual endpoint slice JSON file
  downloadEndpoint: async (documentId, endpointId) => {
    const res = await api.get(`/docs/${documentId}/endpoints/${endpointId}/download`, {
      responseType: 'blob',
    });
    const disposition = res.headers['content-disposition'] || '';
    let filename = `endpoint-${endpointId}.json`;
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = match[1];
    }
    const blob = new Blob([res.data], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },

  // 8. Global search across all indexed endpoints
  searchEndpoints: async (params = {}) => {
    const res = await api.get('/docs/endpoints', { params });
    return unwrap(res);
  },

  // 9. Get document user shares
  getShares: async (documentId) => {
    const res = await api.get(`/docs/${documentId}/shares`);
    return unwrap(res);
  },

  // 10. Grant / update share permission
  saveShare: async (documentId, shareData) => {
    const res = await api.post(`/docs/${documentId}/shares`, shareData);
    return unwrap(res);
  },

  // 11. Revoke share permission
  revokeShare: async (documentId, userId) => {
    const res = await api.delete(`/docs/${documentId}/shares/${userId}`);
    return unwrap(res);
  },

  // 12. Delete documentation
  deleteDocument: async (documentId) => {
    const res = await api.delete(`/docs/${documentId}`);
    return unwrap(res);
  },

  // 13. Search registered ERP users for sharing
  searchUsers: async (query = '') => {
    const res = await api.get('/docs/users/search', { params: { query } });
    return unwrap(res);
  },

  // 14. List distinct module names
  getModules: async () => {
    const res = await api.get('/docs/modules');
    return unwrap(res);
  },
};

export default docsApi;
